import BaseClient from '@/app/model/api/response/baseApiClient'

class LogoutApi extends BaseClient {
  public doLogout (bodyData: {[key:string]: string|number}) {
    const path: string = '/v1/auth/user/signout'

    /* 共通処理 */
    return super.setBody(JSON.stringify(bodyData)).doFetch(process.env.VUE_APP_API_URL + path, 'POST')
  }
}

export default new LogoutApi()
